// The pictures on a user line of an agent session (a coding agent, or Prime's
// lead). The mirror keeps only their names; the bytes are the factory's, behind
// our token, so each is fetched through the app's proxy and shown from a blob
// URL (an <img> cannot send the bearer token). Online only: offline the
// thumbnails say so instead of drawing.
import { api } from '@/runtime'
import { MessagePictures } from '@/components/MessagePictures'
import { PICTURE_FILE } from '@/lib/runSend'
import { useBlobUrls } from '@/hooks/useBlobUrls'
import { createBlobUrls } from '@/lib/blobUrls'

// One URL per picture, shared by every thread on the page; past MAX_CACHED the
// ones nothing shows are let go (lib/blobUrls.ts).
const MAX_CACHED = 32
const urls = createBlobUrls(MAX_CACHED)
// keys are "<run>/<file>": a run is a DNS label and a file matches PICTURE_FILE, neither has a slash
const load = (key: string) => {
  const at = key.indexOf('/')
  return api.factoryPicture(key.slice(0, at), key.slice(at + 1))
}

export const RunPictures = ({ run, files }: { run: string; files: string[] }) => {
  const names = files.filter((f) => PICTURE_FILE.test(f))
  const {
    urls: got,
    online,
    failed,
    broken,
  } = useBlobUrls(
    urls,
    names.map((f) => `${run}/${f}`),
    load,
  )
  const shown = names
    .filter((f) => got[`${run}/${f}`])
    .map((f) => ({ url: got[`${run}/${f}`]!, onError: () => broken(`${run}/${f}`) }))
  if (!names.length) return null
  return (
    <>
      {shown.length > 0 && <MessagePictures images={shown} />}
      {failed && shown.length < names.length && (
        <p className="text-xs text-faint mt-1" data-testid="run-pictures-missing">
          {!online
            ? `${names.length === 1 ? 'A picture' : 'Pictures'} will show when you are online.`
            : `${names.length === 1 ? 'A picture' : 'Some pictures'} could not be fetched from the factory.`}
        </p>
      )}
    </>
  )
}
